"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImThemeOptions = createImThemeOptions;
var _spacing = require("./internal/spacing");
var _typography = require("./internal/typography");
var _getCustomizedComponents = require("./internal/getCustomizedComponents");
var _palettes = require("./internal/palettes");
var _shadows = require("./internal/shadows");
function createImThemeOptions(mode) {
  var palette = (0, _palettes.createImPalette)(mode);
  var shadows = (0, _shadows.createImShadows)();
  return {
    // use MUI default breakpoints values
    components: (0, _getCustomizedComponents.getCustomizedComponents)(palette),
    palette: palette,
    shadows: shadows,
    shape: {
      borderRadius: 6
    },
    spacing: _spacing.spacing,
    typography: _typography.typography
  };
}